var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2458_1793",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.610107,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2458_1793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1816 4.20386C12.1816 3.90698 12.4785 3.61011 12.7754 3.61011C13.1094 3.61011 13.4062 3.90698 13.4062 4.20386V4.83472C16.375 5.13159 18.75 7.65503 18.75 10.7351V11.8484C18.75 13.4441 19.3809 15.0027 20.5312 16.1531L20.6426 16.2644C20.9395 16.5613 21.125 16.9695 21.125 17.4148C21.125 18.3425 20.3828 19.0476 19.4551 19.0476H6.13281C5.20508 19.0476 4.5 18.3425 4.5 17.4148C4.5 16.9695 4.64844 16.5613 4.94531 16.2644L5.05664 16.1531C6.20703 15.0027 6.875 13.4441 6.875 11.8484V10.7351C6.875 7.65503 9.21289 5.13159 12.2188 4.83472L12.1816 4.20386ZM12.7754 5.98511C10.1777 5.98511 8.02539 8.13745 8.02539 10.7351V11.8484C8.02539 13.7781 7.2832 15.6335 5.91016 17.0066L5.79883 17.0808C5.72461 17.1921 5.65039 17.3035 5.65039 17.4148C5.65039 17.6746 5.87305 17.8601 6.13281 17.8601H19.4551C19.7148 17.8601 19.9375 17.6746 19.9375 17.4148C19.9375 17.3035 19.8633 17.1921 19.7891 17.0808L19.6777 17.0066C18.3047 15.6335 17.5625 13.7781 17.5625 11.8484V10.7351C17.5625 8.13745 15.4102 5.98511 12.7754 5.98511ZM12.7754 21.4226C13.2949 21.4226 13.7402 21.1257 13.9258 20.6433C14.0371 20.3464 14.3711 20.1609 14.668 20.2722C14.9648 20.3835 15.1504 20.7175 15.0391 21.0515C14.7051 21.9792 13.8145 22.6101 12.7754 22.6101C11.7734 22.6101 10.8828 21.9792 10.5488 21.0515C10.4375 20.7175 10.623 20.3835 10.9199 20.2722C11.2168 20.1609 11.5508 20.3464 11.6621 20.6433C11.8477 21.1257 12.293 21.4226 12.7754 21.4226Z",
    fill: "#2A2F3B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.38f0662e97177ba649d0662d19d8ffb5.svg";
export { ForwardRef as ReactComponent };